import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export default function ManufacturingSection() {
    return (
        <section className="relative bg-white font-Stix text-gray-900 pt-[72px] lg:pt-[109px]">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: 'url(/images/fabric-texture.jpg)' }}></div>
            <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-12 py-20 lg:py-32">
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-3xl sm:text-4xl font-bold leading-normal text-[#33367b]"
                >
                    Chuyên Gia Vải Thể Thao Cao Cấp
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="mt-4 max-w-3xl  font-OpenSans text-gray-700 text-base font-normal leading-relaxed"
                >
                    TIMO - Nhà cung cấp vải thể thao chuyên nghiệp, với chất liệu vượt trội:
                    co giãn 4 chiều, thoáng khí, thấm hút mồ hôi, bền bỉ.
                </motion.p>
                <Link
                    to="/wishlist"
                    className="mt-6 bg-[#33367b] text-white font-OpenSans font-medium px-4 py-3 hover:bg-indigo-800 transition"
                >
                    Liên hệ với Timo
                </Link>
            </div>
        </section>
    );
}
